function CoreStickyHeaderClassCreator(StickyHeader: import('widgets/global/StickyHeader').TStickyHeader) {
    class CoreStickyHeader extends StickyHeader {
        prefs() {
            return {
                ...super.prefs(),
                classesShow: 'm-header-scroll_up',
                classesHide: 'm-header-scroll_down'
            };
        }

        /**
         * @description Initialize widget logic
         */
        init() {
            this.checkScrollDirection();
        }

        /**
         * @description check scroll direction and add or remove body class
         */
        checkScrollDirection() {
            const bodyScrollUp = this.prefs().classesShow;
            const bodyScrollDown = this.prefs().classesHide;
            const root = document.scrollingElement || document.documentElement;
            const TOL = 2; // for ignore small changes
            let lastY = root.scrollTop;

            const onScroll = () => {
                const y = root.scrollTop;
                const delta = y - lastY;

                if (y <= 0) {
                    document.body.classList.add(bodyScrollUp);
                    document.body.classList.remove(bodyScrollDown);
                    lastY = 0;

                    return;
                }

                if (Math.abs(delta) < TOL) {
                    lastY = y;

                    return;
                }

                if (delta > 0) {
                    document.body.classList.add(bodyScrollDown);
                    document.body.classList.remove(bodyScrollUp);
                } else {
                    document.body.classList.add(bodyScrollUp);
                    document.body.classList.remove(bodyScrollDown);
                }

                lastY = y;
            };

            window.addEventListener('scroll', onScroll, { passive: true });
        }
    }

    return CoreStickyHeader;
}

export type TCoreStickyHeader = ReturnType<typeof CoreStickyHeaderClassCreator>;

export type TCoreStickyHeaderInstance = InstanceType<TCoreStickyHeader>;

export default CoreStickyHeaderClassCreator;
